import actionTypes from '../actionTypes';

export function geStoreDrillDownData(payload) {
	return {
		type: actionTypes.GET_STORE_DRILL_DOWN_DATA,
		payload,
	};
}

export function getStoreDrillDownDataSuccess(payload) {
	return {
		type: actionTypes.GET_STORE_DRILL_DOWN_DATA_SUCCESS,
		payload,
	};
}

export function getStoreDrillDownDataFailure(payload) {
	return {
		type: actionTypes.GET_STORE_DRILL_DOWN_DATA_FAILURE,
		payload,
	};
}
